import { render, staticRenderFns } from "./AccessDeniedPage.vue?vue&type=template&id=287fcf83&scoped=true"
import script from "./AccessDeniedPage.vue?vue&type=script&lang=js"
export * from "./AccessDeniedPage.vue?vue&type=script&lang=js"
import style0 from "./AccessDeniedPage.vue?vue&type=style&index=0&id=287fcf83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287fcf83",
  null
  
)

export default component.exports